import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const FONT_SIZES = [
  'meta',
  'avatar',
  'mono',
  'control',
  'body',
  'body-lg',
  'section',
  'fact',
  'lead',
  'card-title',
  'wordmark',
  'wordmark-lg',
  'plan-title',
  'price',
  'title',
  'title-lg',
  'success',
  'figure',
  'checkout',
  'hero',
  'brand',
];

const RADII = [
  'meter',
  'dot',
  'line',
  'avatar',
  'nav',
  'control',
  'logo',
  'control-lg',
  'tile',
  'card',
  'hero',
];

// Without these groups twMerge reads `text-meta` as a colour and drops it next to `text-muted`.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZES }],
      rounded: [{ rounded: RADII }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
